/* Elite Athletics BFCM sections: fight kit builder, size filter, Lost & Found, tab deep links,
   quick add (+ button) and local currency. No dependencies. Several sections include this file,
   so it guards against running twice. */
(function () {
  if (window.BfcmSections) return;

  // ---------- Helpers ----------

  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Local currency: Liquid prices (variant.price, | money) are already in the visitor's market
  // currency, so we format with that same currency (Shopify.currency.active) via Intl.
  // Falls back to the shop money format if Intl or Shopify.currency is not available.
  function formatMoney(cents, format) {
    try {
      var active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      if (active && window.Intl && Intl.NumberFormat) {
        var locale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || undefined;
        return new Intl.NumberFormat(locale, { style: 'currency', currency: active }).format(cents / 100);
      }
    } catch (e) { /* fall through to the format string */ }

    var fmt = format || '{{amount_with_comma_separator}}';
    function withDelimiters(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        default: return withDelimiters(cents, 2, ',', '.');
      }
    });
  }

  function handleize(text) {
    return String(text).toLowerCase().replace(/&/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // ---------- Quick add (+ button on product cards) ----------

  // Lets the theme or a test override how the cart request is sent.
  function addItemsToCart(items) {
    if (window.BfcmAddToCart) return window.BfcmAddToCart(items);
    return fetch(shopifyRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to your bag.');
        return data;
      });
    });
  }

  var toastEl = null;
  var toastTimer = null;
  function showToast(message, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'bfcm-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.textContent = message + ' ';
    if (!isError) {
      var link = document.createElement('a');
      link.href = shopifyRoot() + 'cart';
      link.textContent = 'View bag';
      toastEl.appendChild(link);
    }
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, isError ? 6000 : 4500);
  }

  // Keeps the header bag count in step when the theme exposes a count element.
  function refreshCartCount() {
    fetch(shopifyRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count, .cart-counter, #cart-count, .cart-count-bubble span[aria-hidden]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      })
      .catch(function () { /* the add itself already worked */ });
  }

  function initQuickAdd() {
    if (window.__bfcmQuickAdd) return;
    window.__bfcmQuickAdd = true;

    function closeAll(except) {
      document.querySelectorAll('[data-bfcm-quick]').forEach(function (panel) {
        if (panel === except) return;
        panel.hidden = true;
        var toggle = panel.parentNode.querySelector('[data-bfcm-quick-add]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }

    function cardVariants(card) {
      try { return JSON.parse(card.getAttribute('data-variants') || '{}'); } catch (e) { return {}; }
    }

    function addVariant(card, trigger, variantId) {
      var titleEl = card.querySelector('.bfcm-card__title');
      var title = titleEl ? titleEl.textContent.trim() : 'Item';
      var addButton = card.querySelector('[data-bfcm-quick-add]');
      var busyEls = [addButton].concat(Array.prototype.slice.call(card.querySelectorAll('[data-bfcm-quick-size]')));
      busyEls.forEach(function (el) { if (el) { el.disabled = true; el.setAttribute('aria-busy', 'true'); } });

      addItemsToCart([{ id: Number(variantId), quantity: 1 }])
        .then(function (data) {
          closeAll();
          showToast(title + ' added to your bag.');
          if (addButton) {
            addButton.classList.add('is-added');
            setTimeout(function () { addButton.classList.remove('is-added'); }, 1600);
          }
          document.dispatchEvent(new CustomEvent('bfcm:cart-added', { bubbles: true, detail: { items: [{ id: Number(variantId), quantity: 1 }], response: data } }));
          refreshCartCount();
        })
        .catch(function (error) {
          showToast(error.message || 'Could not add to your bag. Please try again.', true);
        })
        .finally(function () {
          busyEls.forEach(function (el) { if (el) { el.disabled = false; el.removeAttribute('aria-busy'); } });
        });
    }

    document.addEventListener('click', function (event) {
      var addBtn = event.target.closest('[data-bfcm-quick-add]');
      var sizeBtn = event.target.closest('[data-bfcm-quick-size]');

      if (!addBtn && !sizeBtn) {
        if (!event.target.closest('[data-bfcm-quick]')) closeAll();
        return;
      }

      var card = (addBtn || sizeBtn).closest('[data-bfcm-card]');
      if (!card) return;

      if (sizeBtn) {
        var chosen = cardVariants(card)[sizeBtn.getAttribute('data-size')];
        if (chosen) addVariant(card, sizeBtn, chosen);
        return;
      }

      if (addBtn.getAttribute('data-mode') === 'direct') {
        addVariant(card, addBtn, addBtn.getAttribute('data-variant'));
        return;
      }

      // Sized product: if a size filter is active the card link already points at that size.
      var link = card.querySelector('[data-base-url]');
      var match = link && /[?&]variant=(\d+)/.exec(link.getAttribute('href') || '');
      if (match) {
        addVariant(card, addBtn, match[1]);
        return;
      }

      var panel = card.querySelector('[data-bfcm-quick]');
      if (!panel) return;
      var willOpen = panel.hidden;
      closeAll(panel);
      panel.hidden = !willOpen;
      addBtn.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) {
        var first = panel.querySelector('[data-bfcm-quick-size]');
        if (first) first.focus();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = document.querySelector('[data-bfcm-quick]:not([hidden])');
      if (!open) return;
      var toggle = open.parentNode.querySelector('[data-bfcm-quick-add]');
      closeAll();
      if (toggle) toggle.focus();
    });
  }

  // ---------- Fight kit builder ----------

  function initFightKit(root) {
    var moneyFormat = root.getAttribute('data-money-format');
    var radios = root.querySelectorAll('[data-set-radio]');
    var totalEl = root.querySelector('[data-total]');
    var summaryEl = root.querySelector('[data-summary]');
    var statusEl = root.querySelector('[data-status]');
    var button = root.querySelector('[data-add-set]');
    if (!button) return;

    function activeSet() {
      var checked = root.querySelector('[data-set-radio]:checked');
      return root.querySelector('[data-set="' + (checked ? checked.value : '') + '"]');
    }

    function groupState(group) {
      var input = group.querySelector('input:checked');
      return input ? { id: input.value, size: input.getAttribute('data-size'), price: Number(input.getAttribute('data-price')) } : null;
    }

    function setError(group, message) {
      var error = group.querySelector('[data-error]');
      if (!error) return;
      error.textContent = message || '';
      error.hidden = !message;
    }

    function update() {
      var set = activeSet();
      if (!set) return;
      var groups = set.querySelectorAll('.bfcm-sizes');
      var total = 0;
      var parts = [];
      groups.forEach(function (group) {
        var state = groupState(group);
        var label = group.getAttribute('data-role') === 'rashguard' ? 'Rashguard' : 'Shorts';
        total += state ? state.price : Number(group.getAttribute('data-default-price'));
        parts.push(label + ' ' + (state ? state.size : 'not chosen'));
        var value = group.querySelector('[data-size-value]');
        if (value) value.textContent = state ? ': ' + state.size : '';
      });
      totalEl.textContent = formatMoney(total, moneyFormat);
      var anyChosen = set.querySelector('.bfcm-sizes input:checked');
      summaryEl.textContent = anyChosen ? parts.join(' · ') : 'Choose both sizes to add the set.';
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        root.querySelectorAll('[data-set]').forEach(function (panel) { panel.hidden = panel.getAttribute('data-set') !== radio.value; });
        root.querySelectorAll('[data-set-photo]').forEach(function (photo) { photo.hidden = photo.getAttribute('data-set-photo') !== radio.value; });
        root.querySelectorAll('.bfcm-set-option').forEach(function (option) { option.classList.toggle('is-selected', option.contains(radio)); });
        statusEl.hidden = true;
        update();
      });
    });

    root.addEventListener('change', function (event) {
      var group = event.target.closest('.bfcm-sizes');
      if (!group) return;
      setError(group, '');
      update();
    });

    // Lets the theme or a test override how the cart request is sent.
    var addToCart = window.BfcmAddToCart || function (items) {
      return fetch(root.getAttribute('data-cart-add-url') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add the set.');
          return data;
        });
      });
    };

    button.addEventListener('click', function () {
      var set = activeSet();
      if (!set) return;
      var setName = set.getAttribute('data-set-name');
      var items = [];
      var firstInvalid = null;
      set.querySelectorAll('.bfcm-sizes').forEach(function (group) {
        var state = groupState(group);
        var label = group.getAttribute('data-role') === 'rashguard' ? 'rashguard' : 'shorts';
        if (!state) {
          setError(group, 'Choose a ' + label + ' size.');
          if (!firstInvalid) firstInvalid = group;
          return;
        }
        items.push({ id: Number(state.id), quantity: 1, properties: { Set: setName, _bfcm_set: setName } });
      });
      if (firstInvalid) {
        var focusTarget = firstInvalid.querySelector('input:not(:disabled)');
        if (focusTarget) focusTarget.focus();
        return;
      }

      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      addToCart(items)
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('bfcm:cart-added', { bubbles: true, detail: { set: setName, items: items, response: data } }));
          refreshCartCount();
          if (root.getAttribute('data-after-add') === 'cart_page') {
            window.location.href = root.getAttribute('data-cart-url');
            return;
          }
          statusEl.classList.remove('is-error');
          statusEl.innerHTML = '';
          statusEl.append(setName + ' added to your bag. ');
          var link = document.createElement('a');
          link.href = root.getAttribute('data-cart-url');
          link.textContent = 'View bag';
          statusEl.append(link);
          statusEl.hidden = false;
        })
        .catch(function (error) {
          statusEl.classList.add('is-error');
          statusEl.textContent = error.message || 'Could not add the set. Please try again.';
          statusEl.hidden = false;
        })
        .finally(function () {
          button.removeAttribute('aria-busy');
          button.disabled = false;
        });
    });

    update();
  }

  // ---------- Size filter (product grid and Lost & Found) ----------

  function initGrid(root) {
    var isLostFound = root.hasAttribute('data-lost-found');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var tabButtons = root.querySelectorAll('[data-tab-button]');
    var sizeButtons = root.querySelectorAll('[data-size-button]');
    var clearButtons = root.querySelectorAll('[data-size-clear]');
    var statusEl = root.querySelector('[data-status]');
    var emptyEl = root.querySelector('[data-empty]');
    var state = { tab: tabs.length ? tabs[0].getAttribute('data-tab') : null, size: null };

    function cardSizes(card) {
      return (card.getAttribute('data-sizes') || '').split('|').filter(Boolean);
    }

    function cardVariants(card) {
      try { return JSON.parse(card.getAttribute('data-variants') || '{}'); } catch (e) { return {}; }
    }

    function render() {
      var visible = 0;
      var activeTab = null;
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-tab') === state.tab;
        tab.hidden = !isActive;
        if (isActive) activeTab = tab;
      });
      if (activeTab) {
        activeTab.querySelectorAll('[data-bfcm-card]').forEach(function (card) {
          // Variant level: the card only matches if a buyable variant exists in this size.
          var show = !state.size || cardSizes(card).indexOf(state.size) !== -1;
          card.hidden = !show;
          if (show) visible++;
          var link = card.querySelector('[data-base-url]');
          var variantId = state.size ? cardVariants(card)[state.size] : null;
          if (link) link.href = link.getAttribute('data-base-url') + (variantId ? '?variant=' + variantId : '');
          card.querySelectorAll('.bfcm-chip').forEach(function (chip) {
            chip.classList.toggle('is-match', !!state.size && chip.getAttribute('data-size') === state.size && !chip.classList.contains('is-out'));
          });
          var badge = card.querySelector('[data-bfcm-size-badge]');
          if (badge) {
            badge.textContent = state.size && show ? state.size : '';
            badge.hidden = !(state.size && show);
          }
        });
      }

      tabButtons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-tab-button') === state.tab)); });
      sizeButtons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-size-button') === state.size)); });
      root.querySelectorAll('.bfcm-size-filter__clear').forEach(function (b) { b.hidden = !state.size; });

      var empty = !!state.size && visible === 0;
      if (emptyEl) emptyEl.hidden = !empty;
      if (activeTab) activeTab.hidden = activeTab.hidden || empty;

      if (statusEl) {
        var label = activeTab ? activeTab.getAttribute('data-tab-label') : '';
        var noun = visible === 1 ? 'item' : 'items';
        if (empty) statusEl.textContent = '';
        else if (state.size) statusEl.textContent = visible + ' ' + noun + (isLostFound ? ' in size ' + state.size + '.' : ' in ' + label + ' available in ' + state.size + '.');
        else statusEl.textContent = visible + ' ' + noun + ' in ' + label + '.' + (isLostFound ? ' Pick a size to see what fits.' : '');
      }
    }

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () { state.tab = button.getAttribute('data-tab-button'); render(); });
    });
    sizeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var size = button.getAttribute('data-size-button');
        state.size = state.size === size ? null : size;
        render();
      });
    });
    clearButtons.forEach(function (button) {
      button.addEventListener('click', function () { state.size = null; render(); });
    });

    root.bfcmSelectTab = function (handle) {
      var match = tabs.filter(function (t) { return t.getAttribute('data-tab-handle') === handle; })[0];
      if (match) { state.tab = match.getAttribute('data-tab'); render(); }
    };

    render();
  }

  // ---------- Deep links such as #shop-your-size/clothing ----------

  function goToHash(hash) {
    var raw = decodeURIComponent((hash || '').replace(/^#/, ''));
    if (!raw) return false;
    var parts = raw.split('/');
    var section = document.getElementById(parts[0]);
    if (!section || !section.closest('.bfcm, .bfcm-section-wrap')) return false;
    if (parts[1] && typeof section.bfcmSelectTab === 'function') section.bfcmSelectTab(handleize(parts[1]));
    section.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    var heading = section.querySelector('.bfcm-heading__title');
    if (heading) heading.focus({ preventScroll: true });
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link || link.origin !== window.location.origin || link.pathname !== window.location.pathname) return;
    if (goToHash(link.hash)) {
      event.preventDefault();
      history.replaceState(null, '', link.hash);
    }
  });

  function init() {
    initQuickAdd();
    document.querySelectorAll('[data-bfcm-fight-kit]').forEach(initFightKit);
    document.querySelectorAll('[data-bfcm-grid]').forEach(initGrid);
    if (window.location.hash) goToHash(window.location.hash);
  }

  // Re-run when sections are added or changed in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-bfcm-fight-kit]').forEach(initFightKit);
    event.target.querySelectorAll('[data-bfcm-grid]').forEach(initGrid);
  });

  window.BfcmSections = { formatMoney: formatMoney, goToHash: goToHash };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
